import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../_services/authentication.service';
import { GeneralService } from '../_services/general.service';
import { ToastService } from '../_services/toast.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private toast: ToastService,
    private generalService: GeneralService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        this.authenticationService.setLoading(false);
        this.generalService.setBtnLoader(false);
        const error = err?.error?.message || err?.statusText;

        if (err?.status === 401) {
          this.authenticationService.logout();
          this.toast.show('Error', error, 'danger');
          return throwError(() => err);
        }

        const isCheckLnsEndpoint = request.url.includes('/check-lns');
        if (isCheckLnsEndpoint && (err?.status === 404 || err?.status === 400)) {
          return throwError(() => err);
        }

        this.toast.show('Error', error, 'danger');
        return throwError(() => err);
      })
    );
  }
}
